import React, {useState} from 'react';
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import { Col, Row } from "react-bootstrap";
import { Card } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faEnvelope, faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
import Map from "../Map/Map";
import {ProductsList} from "../ProductsList/ProductsList";

const ContactUs = () => {
    const [searchTerm, setSearchTerm] = useState("");
    return (
        <div className="bg-offWhite p-0">
            <NavBar products={ProductsList} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
            <div style={{ paddingTop: "12rem" }}>
                <div className="d-flex justify-content-center " style={{ backgroundColor: "#A6CE3A" }}>
                    <h2 className="text-white fw-bold pt-5 pb-4 ">CONTACT US</h2>
                </div>
                <Row className="d-flex justify-content-center align-items-center px-5">
                    <Col lg={3} md={6} xs={12} className="mt-5 d-flex justify-content-center align-items-center">
                        <Card className="p-5 text-center" style={{ width: '100%', minHeight: '200px' }}>
                            <Row className="mb-5 d-flex align-items-center justify-content-center">
                                <FontAwesomeIcon icon={faLocationDot} className="me-3 fs-40 text-green" />
                            </Row>
                            <Row>
                                <span className="custom-fs-6">Opposite Al-Noor Little School Nomania Road Gujranwala</span>
                            </Row>
                        </Card>
                    </Col>
                    <Col lg={3} md={6} xs={12} className="mt-5 d-flex justify-content-center align-items-center">
                        <Card className="p-5 text-center" style={{ width: '100%', minHeight: '207px' }}>
                            <Row className="mb-5 d-flex align-items-center justify-content-center">
                                <FontAwesomeIcon icon={faPhone} className="me-3 fs-40 text-green" />
                            </Row>
                            <Row>
                                <span className="custom-fs-6">Mob: (+92) 305 4973841</span>
                            </Row>
                        </Card>
                    </Col>
                    <Col lg={3} md={6} xs={12} className="mt-5 d-flex justify-content-center align-items-center">
                        <Card className="p-5 text-center" style={{ width: '100%', minHeight: '200px' }}>
                            <Row className="mb-5 d-flex align-items-center justify-content-center">
                                <FontAwesomeIcon icon={faClock} className="me-3 fs-40 text-green" />
                            </Row>
                            <Row>
                                <span className="custom-fs-6">Mon-Thur: 09:00 A.M - 7:00 P.M</span>
                                <span className="custom-fs-6">Sat-Sun: 09:00 A.M - 7:00 P.M</span>
                            </Row>
                        </Card>
                    </Col>
                    <Col lg={3} md={6} xs={12} className="mt-5 d-flex justify-content-center align-items-center">
                        <Card className="p-5 text-center" style={{ width: '100%', minHeight: '200px' }}>
                            <Row className="mb-5 d-flex align-items-center justify-content-center">
                             <FontAwesomeIcon icon={faEnvelope} className="me-3 fs-40 text-green" />
                            </Row>
                            <Row>
                                <span className="custom-fs-6">info@sksfans.com</span>
                                <span className="custom-fs-6">complaints@sksfans.com</span>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Map/>
                <Footer />
            </div>
        </div>
    )
}
export default ContactUs;